import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  customVariables: ['~/assets/variables.scss'],
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#03378D',
        middle: '#072E97',
        accent: '#03A9F4',
        success: '#339900',
        grey: '#C1C1C1',
        green: '#1AB88C',
        link: '#007AFF',
        'dark-grey': '#455a64',
        'blue-light': '#007EE0',
        'blue-semi': '#6a89bf',
        'green-light': '#72BF66'
      }
    }
  }
})
